import {
  createPermitApplicationTask,
  deletePermitApplicationTask,
  listPermitApplicationTasks,
  updatePermitApplicationTask,
} from "@/api/permit_application_tasks";
import { WorkflowTaskChecklist } from "@/components/workflow_tracking/WorkflowTaskChecklist";
import { invalidatePermitSuitePipeline } from "@/lib/permitSuiteQueryKeys";

type PermitApplicationTasksProps = {
  municipalityId: number;
  applicationId: number;
};

export function PermitApplicationTasks({ municipalityId, applicationId }: PermitApplicationTasksProps) {
  const tasksQueryKey = ["permit_application_tasks", municipalityId, applicationId] as const;
  const eventsQueryKey = ["permit_application_events", municipalityId, applicationId] as const;

  return (
    <WorkflowTaskChecklist
      testId="permit-application-tasks"
      heading="Tasks"
      description="Break review work into checkable steps for your team."
      tasksQueryKey={tasksQueryKey}
      eventsQueryKey={eventsQueryKey}
      listTasks={() => listPermitApplicationTasks(municipalityId, applicationId)}
      createTask={(payload) => createPermitApplicationTask(municipalityId, applicationId, payload)}
      updateTask={(taskId, patch) =>
        updatePermitApplicationTask(municipalityId, applicationId, taskId, patch)
      }
      deleteTask={(taskId) => deletePermitApplicationTask(municipalityId, applicationId, taskId)}
      onInvalidatePipeline={(queryClient) => invalidatePermitSuitePipeline(queryClient, municipalityId)}
    />
  );
}
